import { OutboundCtaLink } from "@/landing/components/OutboundCtaLink";
import { signupCtaLabel } from "@/landing/lib/constants";
import { Prefooter } from "@/landing/wab/components/Prefooter";
import { useRevealObserver } from "@/landing/wab/lib/use-reveal";

/**
 * The /wab Prefooter (Silk-shader closing CTA) reused verbatim on the main
 * landing. The `.wab-root` wrapper scopes all of wab.css to this block so it
 * never leaks into the rest of the Steward landing, and useRevealObserver()
 * drives the `.reveal` fade-in (the same observer the /wab page mounts).
 */
export function LandingPrefooter({
  isStandalone = false,
}: {
  isStandalone?: boolean;
} = {}) {
  useRevealObserver();
  return (
    <div className="wab-root">
      <Prefooter
        title="The safest way to automate your LinkedIn using Claude, Codex or Openclaw"
        showInstall={false}
        signedOutLabel="Try now"
        signedInLabel="Try now"
        ctaNode={
          isStandalone ? (
            <OutboundCtaLink className="prefooter-cta" placement="prefooter">
              {signupCtaLabel("Try now")} <span className="arr">→</span>
            </OutboundCtaLink>
          ) : undefined
        }
      />
    </div>
  );
}
